/**
 * Import Swiper and its css.
 */
import Swiper from "swiper";
import "swiper/css/bundle";

/**
 * ProjectsSlideshowHandler
 *
 * This class handles the slideshow for the slideshow acf block.
 *
 * @author Alexander Uhlemann
 */
export default class ProjectsSlideshowHandler {
	/**
	 * Constructor
	 *
	 * @author Alexander Uhlemann
	 * @since 1.0.0
	 */
	constructor() {
		this.initSwiper();
	}

	/**
	 * Initialise the swiper.
	 *
	 * @author Alexander Uhlemann
	 * @since 1.0.0
	 *
	 * @return void
	 */
	initSwiper() {
		const swiper = new Swiper(".projects-slideshow", {
			spaceBetween: 16,
			slidesPerView: "auto",

			770: {
				spaceBetween: 32,
			},
		});
	}
}
